import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ProductCard } from './ProductCard';
import { BASE_URL } from '../apis/constant';

const RelatedProduct = ({ productId }) => {
  const [loading, setLoading] = useState(true);
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (!productId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.post(`${BASE_URL}/api/get_related_product_by_id/`, {
          product_id: productId
        });
        
        setRelatedProducts(response.data.data || []);
      } catch (error) {
        console.error('Error fetching related products:', error);
        setRelatedProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRelatedProducts();
  }, [productId]);

  if (relatedProducts.length === 0 && !loading) {
    return null;
  }

  return (
    <section className="w-full mt-[40px]">
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
            Related Products
          </h2>
        </div>

        <div className="
          grid 
          grid-cols-2 
          md:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] 
          gap-3 
          sm:gap-5
        ">
          {loading ? (
            [...Array(4)].map((_, index) => (
              <ProductCardSkeleton key={index} />
            ))
          ) : (
            relatedProducts.map((product) => (
              <div key={product.id} className="w-full">
                <ProductCard product={product} />
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

// Skeleton component for loading state
const ProductCardSkeleton = () => (
  <div className="w-full">
    <div className="animate-pulse">
      <div className="bg-gray-200 rounded-xl aspect-[3/4] mb-3"></div>
      <div className="h-4 bg-gray-200 rounded mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-3/4"></div>
    </div>
  </div>
);

export default RelatedProduct;